import { autoCompleteFetch } from '../../../api/forms';
import endpoints from '../../../api/endpoints';

export function autoCompleteLicenseTypes(search: string = ''): Promise<*> {
  const searchFields: string = '';

  return autoCompleteFetch(endpoints.requestForm.license.types, search, searchFields);
}
